var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profileMissing)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" Your email address must be confirmed before your account is activated. Please check your email for the confirmation link. ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }